module.exports = __webpack_public_path__ + "img/6移动原子20220420_100913.e5a911fa.gif";